import api from '@/services/axios';

// Holt den eingeloggten User (setzt voraus, dass dein /users/me is_admin ODER role: "Admin" liefert)
export async function fetchMe() {
  const { data } = await api.get('/users/me');
  return data; // z.B. { id, first_name, last_name, role, is_admin: true/false, ... }
}
